import type { SVGProps } from 'react'

export const SvgBicycle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    fill="none"
    stroke="currentColor"
    strokeWidth={3.33333}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <path d="M30.8333 35C34.055 35 36.6667 32.3883 36.6667 29.1666C36.6667 25.945 34.055 23.3333 30.8333 23.3333C27.6117 23.3333 25 25.945 25 29.1666C25 32.3883 27.6117 35 30.8333 35Z" />
    <path d="M9.16683 35C12.3885 35 15.0002 32.3883 15.0002 29.1666C15.0002 25.945 12.3885 23.3333 9.16683 23.3333C5.94517 23.3333 3.3335 25.945 3.3335 29.1666C3.3335 32.3883 5.94517 35 9.16683 35Z" />
    <path d="M25.0002 10C25.9206 10 26.6668 9.25383 26.6668 8.33335C26.6668 7.41288 25.9206 6.66669 25.0002 6.66669C24.0797 6.66669 23.3335 7.41288 23.3335 8.33335C23.3335 9.25383 24.0797 10 25.0002 10Z" />
    <path d="M20 29.1666V23.3333L15 18.3333L21.6667 13.3333L25 18.3333H28.3333" />
  </svg>
)
